import React from "react";
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import CloseIcon from "@mui/icons-material/Close";
import "./CustomModal.css";

// Réplica de AedasModal (aedas-library), que no se puede instalar aquí porque
// requiere React 18. Mantiene la API anterior de CustomModal.

type ModalButton = {
  content: React.ReactNode; // texto del botón
  primary: boolean; // botón primario (relleno) o secundario (texto subrayado)
  action: () => void;
  disabled?: boolean;
};

type CustomModalProps = {
  show: boolean;
  onChange: (show: boolean) => void;
  title?: React.ReactNode;
  body: React.ReactNode;
  size?: "sm" | "md" | "lg" | "xl";
  buttons?: ModalButton[];
};

// Ancho en % de pantalla, igual que la prop "width" de AedasModal
const widthBySize = { sm: 30, md: 40, lg: 50, xl: 80 };

export default function CustomModal(props: CustomModalProps) {
  const { body, size = "md", show, onChange, title, buttons } = props;
  const isLarge = size === "xl";
  const handleClose = () => onChange(!show);

  return (
    <Modal
      open={show}
      onClose={handleClose}
      aria-labelledby="custom-modal-title"
      className="aedasModal"
    >
      <Box
        className="aedasModal__box"
        sx={{ width: { xs: "95%", md: `${widthBySize[size]}%` } }}
      >
        <div className="aedasModal__container">
          <div className="aedasModal__header">
            <CloseIcon
              className="aedasModal__close"
              onClick={handleClose}
              aria-label="Cerrar"
              role="button"
            />
            {title ? (
              <h2 id="custom-modal-title" className="section-title aedasModal__title">
                {title}
              </h2>
            ) : null}
          </div>

          <div
            className={[
              "aedasModal__body",
              isLarge ? "aedasModal__body--large" : "",
              buttons && buttons.length > 0 ? "" : "aedasModal__body--noFooter",
            ].join(" ")}
          >
            {body}
          </div>

          {buttons && buttons.length > 0 ? (
            <div
              className={
                isLarge
                  ? "aedasModal__footer aedasModal__footer--large"
                  : "aedasModal__footer"
              }
            >
              {buttons?.map((button, index) => (
                <Button
                  key={index}
                  variant={button.primary ? "contained" : "text"}
                  className={button.primary ? "" : "aedasModal__secondaryButton"}
                  onClick={button.action}
                  disabled={button.disabled}
                >
                  {button.content}
                </Button>
              ))}
            </div>
          ) : (
            <div className="aedasModal__spacer" />
          )}
        </div>
      </Box>
    </Modal>
  );
}
